import { PayloadAction, createListenerMiddleware } from '@reduxjs/toolkit';

import { fetchPlayerConfigSyncAction } from '@pp/core/src/store/apiActions/fetchPlayerConfigSyncAction';

import { GameRootState } from '../../GameStore';
import { highflyerGameStateActions } from '../highflyerGame/slice';

export const gameSettingsMiddleWare = createListenerMiddleware();
const actions = [
  highflyerGameStateActions.isSecondBetBoardToggle,
  highflyerGameStateActions.isAnimationToggle,
  highflyerGameStateActions.setHfHideMyBets,
];
actions.forEach((action) => {
  gameSettingsMiddleWare.startListening({
    actionCreator: action,
    effect: (action, { dispatch, getState }) => {
      const state = getState() as GameRootState;
      const session = state.config.session;

      if (!session) return;
      const { JSESSIONID, actualWebServer: url } = session;
      if (!(JSESSIONID && url)) return;

      const body = generateBody(action, getState() as GameRootState);
      const timeStamp = Date.now();

      dispatch(
        fetchPlayerConfigSyncAction({
          JSESSIONID,
          ck: timeStamp.toString(),
          url: `${url}/api/ui/savePlayerConfigGeneric`,
          body,
        })
      );
    },
  });
});

const generateBody = (action: PayloadAction<any>, state: GameRootState): Record<string, unknown> => {
  const { type } = action;
  switch (type) {
    case highflyerGameStateActions.isSecondBetBoardToggle.type: {
      const isSecondBetBoardEnabled = state.highflyerGameState.settings.isSecondBetBoardToggle;
      return {
        issecondbetboardenabled: isSecondBetBoardEnabled,
      };
    }
    case highflyerGameStateActions.isAnimationToggle.type: {
      const isAnimationToggle = state.highflyerGameState.settings.isAnimationToggle;
      return {
        hf_animation_enabled: isAnimationToggle,
      };
    }
    case highflyerGameStateActions.setHfHideMyBets.type: {
      const hideMyBets = state.highflyerGameState.settings.hfHideMyBets;
      return {
        hfhidemybets: hideMyBets,
      };
    }
    default:
      return {};
  }
};
